import React from 'react';
import { Table } from 'tea-component';
import { useIntl } from 'umi';
import { sentimentType, mathFormat } from '@/pages/opinion/utils';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { brandHealthFormat, sentimentFormat } from '@op/utils/value';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';

const { scrollable } = Table.addons;

export default function TableCommon(props: any) {
  const { formatMessage } = useIntl();
  const { goPage } = useDrilldownParams();
  const {
    data = [],
    filter,
    keywordData,
    language,
    chartClickAble = true,
    height = 250,
    needBrandHealth = false,
    keywordClick,
  } = props;

  const { Keyword_Color } = useGetSingePageSourceRule({
    keys: 'Keyword_Color',
  });

  function getSentimentColumns(): any {
    if (Keyword_Color) return [];
    return [
      {
        key: 'sentiment',
        header: formatMessage({
          id: needBrandHealth ? 'Brand Health' : 'Sentiment',
        }),
        align: 'right',
        render: (item: any) => (
          <span>
            {needBrandHealth
              ? brandHealthFormat(item.sentiment)
              : sentimentFormat(item.sentiment)}
          </span>
        ),
      },
    ];
  }

  return (
    <Table
      verticalTop
      records={data}
      className="dbo-table"
      columns={[
        {
          key: 'Keywords',
          header: formatMessage({ id: 'Keywords' }),
          render: (cvm: any) => {
            const type = sentimentType(cvm.sentiment, true, needBrandHealth);
            const classNameMap: any = {
              1: 'green-text',
              2: 'red-text',
              3: 'nomal-text',
            };
            const realType = Keyword_Color ? 3 : type;
            return (
              <span
                className={classNameMap[realType]}
                onClick={() => {
                  if (!chartClickAble) return;

                  const transObj: any = {
                    origin: 'keyword',
                    en: 'keyword_en',
                    zh: 'keyword_cn',
                  };

                  const keywordItem = keywordData?.filter(
                    (v: any) => v[transObj[language]] == cvm?.name,
                  )[0];

                  const keywordChild = keywordItem?.child;

                  let keyword = [];

                  if (Array.isArray(keywordChild) && keywordChild?.length > 0) {
                    keyword = keywordChild.map((item) => item.keyword);
                  }

                  if (keywordClick) {
                    return keywordClick(keyword);
                  }

                  goPage({
                    path: '/opinion/Stats/Detail',
                    filter: {
                      filter: {
                        ...filter,
                        keyword,
                      },
                      statsDetailType: 'performance-keyword',
                    },
                  });
                }}
              >
                {cvm.name}
              </span>
            );
          },
        },
        {
          key: 'mentions',
          header: formatMessage({ id: 'Mentions' }),

          align: 'right',
          render: (item) => <span>{mathFormat(item.mentions)}</span>,
        },
        ...getSentimentColumns(),
      ]}
      addons={[
        scrollable({
          maxHeight: height,
        }),
      ]}
    />
  );
}
